<div class="row">
    <div class="col-sm-6">
        <div style="text-align: right;" *ngIf="WriteAction">
            <button mat-raised-button color="primary" (click)="add()">
                Add
            </button>
        </div>
        <table mat-table matSort matSortActive="occurance" matSortDirection="asc" matSortDisableClear [dataSource]="dataSource" style="width: 100%;">
            <ng-container matColumnDef="documentType">
                <th mat-header-cell *matHeaderCellDef mat-sort-header><strong>Type</strong></th>
                <td mat-cell *matCellDef="let element"> {{element.documentType}} </td>
            </ng-container>
            <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Description </th>
                <td mat-cell *matCellDef="let element"> {{element.description}} </td>
            </ng-container>
            <ng-container matColumnDef="requestDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Requested </th>
                <td mat-cell *matCellDef="let element"> {{element.requestDate | date:'MM/dd/yyyy'}} </td>
            </ng-container>
            <ng-container matColumnDef="receiveDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Received </th>
                <td mat-cell *matCellDef="let element"> {{element.receiveDate | date: 'MM/dd/yyyy'}} </td>
            </ng-container>
            <ng-container matColumnDef="isOfficial">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Official </th>
                <td mat-cell *matCellDef="let element"> {{element.isOfficial?'Yes':'No'}} </td>
            </ng-container>           
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row matRipple [ngClass]="{'row_select': row.studentDocumentId === this.studentDocument.studentDocumentId }" (click)="editDocument(row.studentDocumentId)" *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <mat-paginator [pageSizeOptions]="[20, 30]" showFirstLastButtons></mat-paginator>
    </div>
    <div class="col-sm-6" *ngIf="isShown" [ngClass]="{disabledDiv: !WriteAction}">
        <div [formGroup]="studentDocumentFormGroup">
            <div class="row" style="text-align: right;" *ngIf="WriteAction">
                <div class="col-sm-12">
                    <button mat-raised-button color="primary" [disabled]="!studentDocumentFormGroup.valid"
                        (click)="onSubmit()">
                        {{this.studentDocument && this.studentDocument.studentDocumentId !== null ? 'Update': 'Save'}}
                    </button>&nbsp;
                    <button mat-raised-button (click)="cancel()">
                        Cancel
                    </button>
                    &nbsp;
                    <button *ngIf="this.studentDocument.studentDocumentId !== null" mat-raised-button (click)="received(this.studentDocument.studentDocumentId)">
                        Received
                    </button>
                    &nbsp;
                    <button color="warn" *ngIf="this.studentDocument.studentDocumentId !== null" mat-raised-button (click)="deleteDocument(this.studentDocument.studentDocumentId)">
                        Delete
                    </button>
                </div>
            </div>
            <br>
            <mat-divider></mat-divider>
            <br>
            <div class="row">
                <div class="col-sm-6">
                    <mat-form-field style="display:flex;flex-direction: column">
                        <mat-label>Document Type</mat-label>
                        <mat-select required placeholder="Document Type" (selectionChange)="onSelectDocumentTypeChange($event)" formControlName="documentTypeId">
                            <mat-option>--Select--</mat-option>                           
                            <ng-container *ngFor="let item of documentTypes">
                                <mat-option *ngIf="evalBind(item,studentDocument.documentTypeId)" [value]="item.id">
                                    {{item.description}}
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-sm-6">
                </div>
            </div>
            <div class="row"*ngIf="!isHighSchool">
                <div class="col-sm-8">
                    <mat-form-field [hidden]="true">
                        <input matInput formControlName="documentSourceTypeId">
                    </mat-form-field>
                    <div *ngIf="this.studentDocument.documentSourceTypeId != null; else elseBlock">
                        <span>University</span><br />
                        <span><strong>{{this.studentDocument.institutionDescription}}</strong></span>
                    </div>
                    <ng-template #elseBlock>
                        <mat-form-field style="display:flex;flex-direction: column;">
                            <mat-label>University</mat-label>
                            <input matInput (focus)="openDialog()" formControlName="institutionDescription"
                                placeholder="University">
                        </mat-form-field>
                    </ng-template>
                </div>
                <div class="col-sm-4" *ngIf="WriteAction">
                    <button mat-raised-button color="primary" (click)="openDialog()">
                        <mat-icon>{{this.studentDocument.documentSourceTypeId != null ? 'edit':'search'}}</mat-icon>
                        {{this.studentDocument.documentSourceTypeId != null ? 'Edit':'Search'}}
                    </button>
                </div>
            </div> 
            <div class="row" *ngIf="isHighSchool">
                <div class="col-sm-8">
                    <mat-form-field [hidden]="true">
                        <input matInput formControlName="highSchoolInstitutionId">
                    </mat-form-field>
                    <div *ngIf="this.studentDocument.highSchoolInstitutionId != null; else elseBlock">
                        <span>High School</span><br />
                        <span><strong>{{this.studentDocument.highSchoolDescription}}</strong></span>
                    </div>
                    <ng-template #elseBlock>
                        <mat-form-field style="display:flex;flex-direction: column;">
                            <mat-label>High School</mat-label>
                            <input matInput (focus)="openDialog()" formControlName="highSchoolDescription"
                                placeholder="High School">
                        </mat-form-field>
                    </ng-template>
                </div>
                <div class="col-sm-4">
                    <button mat-raised-button color="primary" (click)="openDialog()">
                        <mat-icon>{{this.studentDocument.highSchoolInstitutionId != null ? 'edit':'search'}}</mat-icon>
                        {{this.studentDocument.highSchoolInstitutionId != null ? 'Edit':'Search'}}
                    </button>
                </div>
            </div>           
            <div class="row">
                <div class="col-sm-6">
                    <mat-form-field style="display:flex;flex-direction: column">
                        <mat-label>Request Data</mat-label>
                        <input matInput [matDatepicker]="RequestDate1" placeholder="Request Data"
                            formControlName="requestDate">
                        <mat-datepicker-toggle matSuffix [for]="RequestDate1"></mat-datepicker-toggle>
                        <mat-datepicker #RequestDate1></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-sm-6">
                    <mat-form-field style="display:flex;flex-direction: column">
                        <mat-label>Received Date</mat-label>
                        <input matInput [matDatepicker]="ReceiveDate1" placeholder="Received Date"
                            formControlName="receiveDate">
                        <mat-datepicker-toggle matSuffix [for]="ReceiveDate1"></mat-datepicker-toggle>
                        <mat-datepicker #ReceiveDate1></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <mat-form-field style="display:flex;flex-direction: column">
                        <mat-label>Document Description</mat-label>
                        <input matInput maxlength="100" placeholder="Document Description" formControlName="description">
                    </mat-form-field>
                </div>
                <div class="col-sm-6" style="padding-top: 20px;">
                    <mat-checkbox formControlName="isOfficial">Official</mat-checkbox>
                </div>
            </div>
            <br>
            <mat-divider></mat-divider>
            <br>
            <div class="row" style="text-align: right;" *ngIf="WriteAction">
                <div class="col-sm-12">
                    <button mat-raised-button color="primary" [disabled]="!studentDocumentFormGroup.valid"
                        (click)="onSubmit()">
                        {{this.studentDocument && this.studentDocument.studentDocumentId !== null ? 'Update': 'Save'}}
                    </button>&nbsp;
                    <button  mat-raised-button (click)="cancel()">
                        Cancel
                    </button>
                </div>
            </div>
        </div>
        <br />
        <div *ngIf="isEdit">
            <mat-card>
                <mat-card-header>
                    <mat-card-title><strong>Upload Documents</strong></mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="row" *ngIf="WriteAction">
                        <div class="col-sm-12">
                            <input placeholder="Upload Document" type="file" id="fileDropRef" #fileDropRef
                                (change)="onFileDropped($event);" autocomplete="off" aria-label="Choose File" />
                        </div>
                    </div>
                    <table mat-table matSort [dataSource]="documentDataSource" style="width: 100%;">
                        <ng-container matColumnDef="FileName">
                            <th mat-header-cell *matHeaderCellDef><strong>File Name</strong></th>
                            <td mat-cell *matCellDef="let element"> {{element.fileName}} </td>
                        </ng-container>
                        <ng-container matColumnDef="CreatedDate">
                            <th mat-header-cell *matHeaderCellDef> Created Date </th>
                            <td mat-cell *matCellDef="let element"> {{element.createdDate | date:'MM/dd/yyyy'}} </td>
                        </ng-container>
                        <ng-container matColumnDef="Actions">
                            <th mat-header-cell *matHeaderCellDef> Actions </th>
                            <td mat-cell *matCellDef="let element">
                                <button mat-icon-button [matMenuTriggerFor]="menu">
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu">
                                    <button (click)="download(element)" mat-menu-item>
                                        Download
                                    </button>
                                </mat-menu>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="documentDisplayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: documentDisplayedColumns;"></tr>
                    </table>
                    <mat-paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>
